export default __webpack_public_path__ + "static/media/HEPLPROFILE final-19.97867d4b.jpg";